module.exports = __webpack_public_path__ + "img/post-office-logo.4de622ba.png";